<style lang="scss" src='./LocalWeatherData.scss' scoped></style>
<template src="./LocalWeatherData.html"></template>

<script>
import {
  getLocalWeatherData,
} from '@/api/index';

export default {
  name: 'LocalWeatherData',
  props: {
    
  },
  data() {
    return ({
      stationData: [],
      pagination: {
        stationData: {
          page: 0,
          limit: 100,
          next: null
        }
      },
      loading: {
          stationData: false,
        },
    });
  },
  computed: {
    stationDataFiltered: {
      get() {
          let stationDataAux = this.stationData;
          if (this.stationData) {

            const rowsPerPage = this.pagination.stationData.limit;
            if (this.stationData.length > rowsPerPage) {
              const currentPage = this.pagination.stationData.page;
              const start = (currentPage * rowsPerPage) - rowsPerPage;
              const end = start + rowsPerPage;
              stationDataAux = this.stationData.slice(start, end)
            }
          }
          
          // Set Flag newDay to items in order to know if the next element belongs to same date that the back element
          if (stationDataAux && stationDataAux.length > 0) {
            let lastReadingTime = null;
            stationDataAux = stationDataAux.map((stationData) => {
              const readingTimeObj = new Date(stationData.reading_time);
              let newDay = true;
              if (lastReadingTime) {
                newDay = !(readingTimeObj.getFullYear() === lastReadingTime.getFullYear() &&
                        readingTimeObj.getMonth() === lastReadingTime.getMonth() &&
                        readingTimeObj.getDate() === lastReadingTime.getDate());
                lastReadingTime = newDay ? readingTimeObj : lastReadingTime;
              } else {
                lastReadingTime = readingTimeObj
              }
              return {...stationData, newDay: newDay};
            });
          }
          return stationDataAux;
      },
    },

    startRecords: function(){
      const paginationSD = this.pagination.stationData;
      return (paginationSD.page * paginationSD.limit) - paginationSD.limit + 1;
    },

    endRecords: function(){
      const paginationSD = this.pagination.stationData;
      const end = paginationSD.page * paginationSD.limit;
      return end > this.stationData.length ? this.stationData.length : end;
    },

    canGetStationDataFromStore: function(){
      const paginationSD = this.pagination.stationData;
      const start = (((paginationSD.page + 1) * paginationSD.limit) - paginationSD.limit) + 1;
      return start <= this.stationData.length;
    },

  },
  watch: {
  },

  methods: {
    scrollToTopStationDataTbl() {
      const dateHeaderElement = document.querySelector('.date-header:first-child');
      if (dateHeaderElement) {
        dateHeaderElement.scrollIntoView();
      }
    },

    changeStationDataPage(newPage) {
      this.pagination = {...this.pagination, stationData: {
        ...this.pagination.stationData,
        page: newPage
      }};
      this.scrollToTopStationDataTbl();
    },

    backStationDataPage() {
      this.changeStationDataPage(this.pagination.stationData.page - 1);
    },

    nextStationDataPage() {
      if (this.canGetStationDataFromStore) {
        this.changeStationDataPage(this.pagination.stationData.page + 1);
      } else {
        this.loadStationData();
      }
    },

    resetStationDataPagination() {
      this.pagination = {...this.pagination, stationData: {
        ...this.pagination.stationData,
        next: null,
        page: 0
      }};
    },

    async loadStationData() {
      this.loading.stationData = true;

      let pagination = this.pagination.stationData;
      await getLocalWeatherData(this.$store.state.course.course_id, {
        limit: pagination.limit,
        next: pagination.next
      }).then((response) => {
        this.pagination.stationData = {
          ... this.pagination.stationData,
          next: response.next_page,
          page: ((response.rows && response.rows.length) ?
            this.pagination.stationData.page + 1 : this.pagination.stationData.page)
        };

        if (this.pagination.stationData.page > 1) {
          this.stationData = [...this.stationData, ...response.rows];
        } else {
          this.stationData = response.rows;
        }

        this.loading.stationData = false;
      });
    },

    loadData() {
      this.stationData = [];
      this.resetStationDataPagination();
      this.loadStationData();
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Local Weather Data");
      this.$analytics.logEvent("web_local_weather_data");
    }

    this.loadData();
  },
};
</script>
